// Les OCTETS d'un fichier, en base64 — la forme sous laquelle un fichier d'exemple part au serveur.
// ⚠️ 🔴 JAMAIS SON TEXTE : lire le fichier en UTF-8 (`File.text()`) puis laisser le serveur en refaire des octets
//    abîmait les accents d'un EDIFACT en latin-1 comme d'un XML en UTF-8, et le rapport conservé montrait un canonique
//    faux. Seul le serveur décide comment décoder, exactement comme pour un fichier relevé.

/** Les octets en base64, par tranches : `String.fromCharCode(...octets)` d'un seul tenant dépasse la pile sur un gros fichier. */
export function bytesToBase64(bytes: Uint8Array): string {
  let binary = '';
  for (let i = 0; i < bytes.length; i += 0x8000) binary += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  return btoa(binary);
}
